
import React, { useEffect, useRef, useState } from 'react'
import store from '@/core/store'
import classNames from 'classnames'
import { Collapse } from 'react-collapse'
import { MainSectionHeader2 } from '@/pages/HomePage/FeedContent/Thread/CardMainSection/MainSectionHeader/MainSectionHeader2'
import { CardMainSection } from './CardMainSection/CardMainSection'
import { MessageResponsesSection } from '@/pages/HomePage/FeedContent/Thread/CardMainSection/MessageResponsesSection/MessageResponsesSection'
import * as Sentry from '@sentry/react'

import useRenderEvent from '@/core/hooks/useRenderEvent'
import './Thread.scoped.sass'
import threadsService from '@/app-domains/threads/threads.service'

const MemoizedThread = React.memo(function Thread (props) {
  const [viewType, setViewType] = useState(store.getState().threads.viewType || 'normal')
  const [currentMessageOpened, setCurrentMessageOpened] = useState(false)
  const [hideMessageBody, setHideMessageBody] = useState(false)
  const [thread, setThread] = useState(props.thread)

  useRenderEvent(['UI:view_feed_change'], (type) => {
    setViewType(type)
    threadsService.setViewType(type)
  })

  const toggleMessageOpened = () => {
    setCurrentMessageOpened(!currentMessageOpened)
  }
  const { selected, index, sentryBeforeCapture } = props

  const darkenHeaderIfDense = index % 2 === 0

  // eslint-disable-next-line
  useEffect(() => {
    setMessage(thread.messages.filter((message) => message.isHeadOfThread)[0])
  }, [props.thread])

  // eslint-disable-next-line
  const [message, setMessage] = useState(thread.messages.filter((message) => message.isHeadOfThread)[0])
  const [isMessageRead, setIsMessageRead] = useState(!message?.unopen)
  const messageElement = useRef(null)

  const getActualViewType = () => {
    if (viewType === 'dense') {
      return currentMessageOpened ? 'normal' : 'dense'
    }
  
    return viewType
  }

  useEffect(() => {
    setThread(props.thread)
    const message = props.thread.messages.filter((message) => message.isHeadOfThread)[0]
    setMessage(message)
    setIsMessageRead(!message?.unopen)
  }, [props.thread])

  useRenderEvent([`THREAD:${props.thread.composedid}:RENDER`], (thread) => {
    setThread(thread)
    setHideMessageBody(thread.isDeleted)
  })

  const renderDescendantMessages = () => {
    return thread.messages?.length > 1 && <MessageResponsesSection thread={thread} />
  }

  useRenderEvent([`THREAD:${props.thread.composedid}:UPDATE:REPLY_ADDED`], (thread) => {
    setThread(thread)
  })

  const collapseAndScroll = (val) => {
    setHideMessageBody(val)
    if (val) {
      const container = document.querySelector(`#message-${message.messageid}`)
      container.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  return (<Sentry.ErrorBoundary fallback={<></>} key={thread.id} beforeCapture={(scope) => sentryBeforeCapture(scope, thread)}>
    <section
      className={classNames('post-card', {
        selected,
        [getActualViewType()]: getActualViewType(),
        read: isMessageRead,
        unread: !isMessageRead
      })}
      data-message-id={message.id}
      _message={message.id}
      _read={!message.unopen ? 'true' : 'false'}
      ref={messageElement}
      id={`message-${message.messageid}`}
      >
      <MainSectionHeader2 viewType={getActualViewType()}
        thread={thread} message={message}
        darkenHeaderIfDense={darkenHeaderIfDense}
        toggleMessageOnClick={toggleMessageOpened}
        hideMessageBody={collapseAndScroll}
      />
      {getActualViewType() === 'normal' && <Collapse isOpened={!hideMessageBody}><CardMainSection thread={thread}/></Collapse>}
    </section>
    { getActualViewType() === 'normal' && <Collapse isOpened={!hideMessageBody}>{renderDescendantMessages()}</Collapse> }
  </Sentry.ErrorBoundary>)
})

export default MemoizedThread
